import React from "react"

export default function Error500(): JSX.Element {
  return (
    <>
      <h1>500 Internal Error</h1>

      <h2>An error occurred while processing your request.</h2>
    </>
  )
}
